export const getProviderLinkSelectedFilter = (state) => state.providerLink.selectedFilter;
